// Locale-aware "X minutes ago" formatter built on
// ``Intl.RelativeTimeFormat`` so phrasing tracks the active locale
// (e.g., ``2 days ago`` in EN / ``il y a 2 jours`` in FR) without us
// hand-writing the plural forms.
//
// Picks the largest unit whose value is ≥ 1 — anything fresher than
// a minute reads as "just now" / equivalent in the active locale.

const UNITS = [
  { unit: "year", seconds: 31_536_000 },
  { unit: "month", seconds: 2_592_000 },
  { unit: "week", seconds: 604_800 },
  { unit: "day", seconds: 86_400 },
  { unit: "hour", seconds: 3_600 },
  { unit: "minute", seconds: 60 },
];

export function relativeTime(input, locale) {
  if (!input) return "";
  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return "";

  const now = Date.now();
  const diffSeconds = Math.round((date.getTime() - now) / 1000);
  const absDiff = Math.abs(diffSeconds);

  let rtf;
  try {
    rtf = new Intl.RelativeTimeFormat(locale || undefined, { numeric: "auto" });
  } catch {
    // Some Safari versions trip over unfamiliar locale tags. Fall
    // back to the runtime default rather than crashing the card.
    rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
  }

  if (absDiff < 60) {
    // ``Intl.RelativeTimeFormat`` with ``numeric: "auto"`` returns
    // localised "now" / "maintenant" for a 0-second offset.
    return rtf.format(0, "second");
  }
  for (const { unit, seconds } of UNITS) {
    if (absDiff >= seconds) {
      const value = Math.round(diffSeconds / seconds);
      return rtf.format(value, unit);
    }
  }
  return rtf.format(diffSeconds, "second");
}
